"use client";

import React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  name: "Alexandra Chen",
  quote: "Their strategic approach to portfolio diversification has consistently delivered results that exceed our expectations. A truly professional team that understands global markets.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/avatar_cecile.png",
  initials: "AC"
}, {
  id: 2,
  name: "Marcus Thorne",
  quote: "The depth of market insights provided by the team is unparalleled. They don't just manage wealth; they provide a clear and actionable vision for the future of our assets.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/avatar_james_sarah.png",
  initials: "MT"
}, {
  id: 3,
  name: "Elena Rodriguez",
  quote: "Transparency and integrity are the cornerstones of our partnership. I feel confident knowing my family's legacy is in expert hands with their dedicated advisors.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/avatar_thomas.png",
  initials: "ER"
}];
export default function GuestTestimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}